<template>
	<div>
		<div class="common-header-wrap">
            <mt-header class="common-header" title="Live">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
		<div class="LiveContentBox">
			<div class="LiveContentBoxBanner">
				<img :src="liveimg" />
			</div>
			<div class="LiveContentBoxText">
				<h3>{{livename}}</h3>
				<p v-if="wxdetailsde">Time：{{livetime}}</p>
				<p v-if="detailsde">Time：{{livetime?$moment.unix(livetime).format('YYYY-MM-DD HH:mm'):''}}</p>
			</div>
			
			<div class="ShopCompanyinformationContent">
				<h5>Main Product</h5>
				<div class="informationContentLive">
					<p class="textcontent">{{store_mainbusiness}}</p>
				</div>
			</div>
			
			<div class="ShopCompanyinformationContent">
				<h5>Company Profile</h5>
				<div class="informationContentLive">
					<p class="textcontent">{{store_jieshao}}</p>
				</div>
			</div>
			
		</div>
		
			<div class="subscribeBottom">
		  		<button class="subscribe-btns" @click="golive">More Live</button>
			</div>
		
		
  </div>
</template>

<script>
	import { loadScript } from '../../../util/common'
	import { getWXConfigList,getresultWXConfig,getliveidcontent } from '../../../api/config'
	import { getLiveInfo } from '../../../api/memberLive'
export default {
  data () { 	
    return {
    	openid:'',
    	liveimg:'https://trust-data.oss-cn-shenzhen.aliyuncs.com/file/upload/20220428/399_1651134443232499.png',
    	livename:'',
    	livetime:'',
    	detailsde:false,
    	wxdetailsde:true,
    	live_apply_id:'',
    	store_mainbusiness:'',
    	store_jieshao:''
    }
  },

  created: function(){
  	var _this=this;
  	var liveid=this.$route.query.id;
  	var openids=this.openid;
  	if(this.$route.query.livetypes=="1"){
  		getLiveInfo(liveid).then(res => {
  			this.liveimg=res.result.live_apply_info.live_apply_cover_image_url;
	  		this.livename=res.result.live_apply_info.live_apply_name;
	  		this.livetime=res.result.live_apply_info.live_apply_play_time;
	  		this.store_mainbusiness=res.result.live_store.store_mainbusiness;
	  		this.store_jieshao=res.result.live_store.store_jieshao;
	  		this.detailsde=true;
	  		this.wxdetailsde=false;
  		})
  	}else{
	  	getliveidcontent(liveid).then((res) => {
			openids=res.result.openid;
			_this.live_apply_id=res.result.live_apply_id;
	  		this.liveimg=res.result.live_apply_cover_image_url;
	  		this.livename=res.result.live_apply_name;
	  		this.livetime=res.result.live_apply_play_time;
	  	})
  	}
  	
  	
  },
  computed: {

  },
  methods: { 	
		golive(){
			this.$router.push({ 'name': 'MemberLiveLists' })
		}
  }
}


</script>

<style scoped lang='scss'>
.subscribe-btns{border: none;display: inline-block;width: 100%;background: #FF0000;color: #fff;letter-spacing: 1px;font-size: 1rem;padding: 10px 10px;border-radius: 2rem;cursor: pointer;outline: none;box-sizing: border-box;}

.ShopCompanyinformationContent{margin-top: 0.7rem;background: #fff;}
	.ShopCompanyinformationContent h5{font-size: 0.7rem;color: #333;font-weight: 700;padding: 0.5rem 0.3rem;border-bottom: 1px solid #f5f5f5;}
	.informationContentLive p.textcontent{display: block;width: 100%;text-indent: 2em;color: #333;font-size: 0.65rem;line-height: 1rem;padding: 0.3rem 0.3rem;box-sizing: border-box;}
.LiveContentBox{background: #fff;}
.LiveContentBoxBanner{text-align: center;min-height: 3rem;}
.LiveContentBoxBanner img{display: block;width: 100%;}
.LiveContentBoxText{padding: 0.5rem 0.3rem;padding-bottom: 1rem;}
.LiveContentBoxText h3{font-size: 0.8rem;color: #000;margin: 0;line-height: 1.1rem;}
.LiveContentBoxText p{margin-top: 0.3rem;font-size: 0.7rem;color: #666;line-height: 1rem;}
.subscribeBottom{text-align: center;padding: 0rem 0;width: 80%;margin: 0 auto;position: relative;padding-top: 0rem;margin-top: 1rem;padding-bottom: 3rem;}
.subscribeBottom div{width: 100%;}
.subscribe-btn{border: none;display: inline-block;width: 100%;background: #00b000;color: #fff;letter-spacing: 1px;font-size: 1rem;padding: 10px 0;border-radius: 10px;cursor: pointer;}
.dypligobox{text-align: center;padding: 3rem 0;padding-bottom: 0rem;}
.dypligobox img{width: 90%;max-width: 10rem;}
</style>
